module.exports = __webpack_public_path__ + "img/info.180395bf.png";